<script>
import options from './SiteNavigationSearchMenu.options'
export default options
</script>

<template>
    <section class="nlx-site-navigation__mega-menu-content nlx-site-navigation__search-menu" v-if="showSearchMenu">
        <div class="nlx-site-navigation__search-menu__searchfield">
            <div class="nlx-site-navigation__search-menu__icon-container"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-search" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="10" cy="10" r="7"></circle><line x1="21" y1="21" x2="15" y2="15"></line></svg></div>
            <input class="nlx-site-navigation__search-menu__inputfield" ref="focusTarget" v-model="searchString" @keyup.esc="hideSearchMenu" @keyup.enter="goToSearchPage">
            <button @click="clearSearch" class="nlx-site-navigation__search-menu__clear-search">{{getLabel('clear_search')}}</button>
        </div>

        <div class="nlx-site-navigation__search-menu__products">
            <template v-for="(product,key) in results" :key="key">
                <ProductSpot :productData="product" />
            </template>
        </div>

        <div class="nlx-site-navigation__search-menu__buttons" v-if="totalResultCount">
          <button @click="goToSearchPage" class="nlx-button">{{getLabel('show_all')}} <strong>({{totalResultCount}})</strong></button>
        </div>
    </section>
</template>
